import type { RbacArea, RbacLevel } from '@catalyst-psa/shared';

export const RBAC_AREA_LABELS: Record<RbacArea, string> = {
  agreements: 'Agreements',
  projects: 'Projects',
  time: 'Time',
  customers: 'Customers',
  products: 'Products',
  invoices: 'Invoices',
  tickets: 'Tickets',
  supportTickets: 'Support Tickets',
  projectTickets: 'Project Tickets',
  sales: 'Sales',
  reports: 'Reports',
};

export const RBAC_LEVEL_LABELS: Record<RbacLevel, string> = {
  none: 'None',
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
};
